






















































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Typography, Surface, Picture } from '@/components/atoms';
import { ContentContainer, FilledButton } from '@/components/molecules';
import MarketingCenterService from '@/api/MarketingCenterService';
import { TemplatesDictionary } from '@/models/marketingCenter/template';

@Component({
  components: { ContentContainer, FilledButton, Typography, Surface, Picture }
})
export default class MarketingCenterAssetsDownload extends Vue {
  marketingCenterService = new MarketingCenterService();
  title: string = '';
  images: object[] = [];

  async mounted() {
    const response = await this.marketingCenterService.getPost(
      this.$route.params.post
    );

    const template = TemplatesDictionary[response.data.template];

    this.title = response.data.name;
    this.images = response.data.assets.map(image => ({
      url: image.publicPath.url,
      filename: image.filename,
      format: template.formats.find(format => format.key === image.type)
    }));
  }

  async download(img: string, filename: string) {
    const file = await this.getFile(img);

    const blob = window.URL.createObjectURL(file);

    var a = document.createElement('a');
    a.href = blob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  getFile(img: string) {
    return new Promise(resolve => {
      let blob = null;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', img);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        blob = xhr.response;
        resolve(
          new File([blob], 'share.jpeg', {
            type: 'image/jpeg',
            lastModified: new Date().getMilliseconds()
          })
        );
      };
      xhr.send();
    });
  }

  goto(target: string) {
    const links: any = {
      instagram: 'https://www.instagram.com/twismcoins',
      facebook: 'https://www.facebook.com/twismcoins',
      twitter: 'https://twitter.com/twismcoins',
      linkedin: 'https://www.linkedin.com/company/twism/about',
      faq: 'https://twism.zendesk.com/hc/en-us',
      terms: 'https://twism-launch-landing-dev.subservers.nodo.cc/terms',
      privacy: 'https://twism-launch-landing-dev.subservers.nodo.cc/privacy'
    };

    window.location.href = links[target];
  }

  get iOS() {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }
}
